import Vue from 'vue';
import SpoferanUi from 'spoferan-ui/src/main';

Vue.use(SpoferanUi);